import { useHttp } from '@/api'
import { httpApi } from '@/api/api'

/**
 * 新規注文情報
 */
export function AddCmpMstInfo(data, callBackFn) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.AddCmpMstInfo, data)
      .then(res => {
        resolve(res)
        callBackFn()
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 編集注文情報
 */
export function ChangeCmpMstInfo(data, callBackFn) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.EditCmpMstInfo, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 検索仕入先マスタ情報
 */
export function GetCmpMstInfo() {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.GetCmpMstInfo)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

